import { render, staticRenderFns } from "./XlsxTable.vue?vue&type=template&id=30975b58&"
import script from "./XlsxTable.vue?vue&type=script&lang=js&"
export * from "./XlsxTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports